import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import "./AdminDashboard.css";

function AdminDashboard({ userData }) {
  const { user, logout } = useAuth();
  const [active, setActive] = useState("overview");
  const [openDropdown, setOpenDropdown] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");

  const [users, setUsers] = useState([
    { id: 1, name: "Rahul Sharma", email: "rahul@example.com", role: "student", status: "Active", joined: "2026-01-10" },
    { id: 2, name: "Ananya Verma", email: "ananya@example.com", role: "student", status: "Active", joined: "2026-02-05" },
    { id: 3, name: "Arjun Patel", email: "arjun@example.com", role: "instructor", status: "Active", joined: "2026-01-20" },
    { id: 4, name: "Priya Singh", email: "priya@example.com", role: "student", status: "Inactive", joined: "2026-03-01" },
    { id: 5, name: "Vikram Mehta", email: "vikram@example.com", role: "instructor", status: "Active", joined: "2026-01-15" },
  ]);

  const [courses, setCourses] = useState([
    { id: 1, title: "Full Stack Development", instructor: "Arjun Patel", students: 128, status: "Published", revenue: 48200 },
    { id: 2, title: "React Advanced", instructor: "Vikram Mehta", students: 74, status: "Published", revenue: 29600 },
    { id: 3, title: "DevOps & Cloud", instructor: "Arjun Patel", students: 0, status: "Draft", revenue: 0 },
  ]);

  const [announcements, setAnnouncements] = useState([
    { id: 1, title: "Platform Maintenance", message: "Scheduled maintenance on April 10th.", date: "2026-04-06" },
    { id: 2, title: "New Course Launch", message: "DevOps course launching next week!", date: "2026-04-05" },
  ]);

  const [newAnnouncement, setNewAnnouncement] = useState({ title: "", message: "" });
  const [showAnnouncementForm, setShowAnnouncementForm] = useState(false);

  const displayName =
    userData?.name || user?.displayName || user?.name || user?.email || "Admin";
  const profilePhoto =
    userData?.photoURL || user?.photoURL || userData?.picture || user?.picture || "";
  const getInitials = () =>
    displayName
      .split(" ")
      .filter(Boolean)
      .slice(0, 2)
      .map((n) => n[0])
      .join("")
      .toUpperCase();

  const hasPhoto = Boolean(profilePhoto);

  const showSuccess = (msg) => {
    setSuccessMsg(msg);
    setTimeout(() => setSuccessMsg(""), 3000);
  };

  const handleRoleChange = (userId, newRole) => {
    setUsers(users.map(u => u.id === userId ? { ...u, role: newRole } : u));
    showSuccess("User role updated successfully!");
  };

  const handleStatusToggle = (userId) => {
    setUsers(users.map(u => u.id === userId ? { ...u, status: u.status === "Active" ? "Inactive" : "Active" } : u));
    showSuccess("User status updated!");
  };

  const handleDeleteUser = (userId) => {
    setUsers(users.filter(u => u.id !== userId));
    showSuccess("User removed successfully!");
  };

  const handleToggleCourseStatus = (courseId) => {
    setCourses(courses.map(c =>
      c.id === courseId ? { ...c, status: c.status === "Published" ? "Draft" : "Published" } : c
    ));
    showSuccess("Course status updated!");
  };

  const handleAddAnnouncement = (e) => {
    e.preventDefault();
    if (!newAnnouncement.title || !newAnnouncement.message) return;
    setAnnouncements([
      { id: Date.now(), ...newAnnouncement, date: new Date().toISOString().split("T")[0] },
      ...announcements
    ]);
    setNewAnnouncement({ title: "", message: "" });
    setShowAnnouncementForm(false);
    showSuccess("Announcement posted successfully!");
  };

  const handleDeleteAnnouncement = (id) => {
    setAnnouncements(announcements.filter(a => a.id !== id));
    showSuccess("Announcement deleted!");
  };

  const menuItems = [
    { key: "overview", label: "Overview", icon: "🏠" },
    { key: "users", label: "Manage Users", icon: "👥" },
    { key: "courses", label: "Manage Courses", icon: "📚" },
    { key: "announcements", label: "Announcements", icon: "📢" },
    { key: "analytics", label: "Analytics", icon: "📊" },
    { key: "settings", label: "Settings", icon: "⚙️" },
    { key: "profile", label: "Profile", icon: "👤" },
  ];

  const totalStudents = users.filter(u => u.role === "student").length;
  const totalInstructors = users.filter(u => u.role === "instructor").length;
  const totalRevenue = courses.reduce((a, c) => a + c.revenue, 0);

  const renderContent = () => {
    switch (active) {

      // ── OVERVIEW ──
      case "overview":
        return (
          <div>
            <div className="ad-cards">
              <div className="ad-card">
                <div className="ad-card-icon">👥</div>
                <div><h3>Total Users</h3><p className="ad-card-value">{users.length}</p></div>
              </div>
              <div className="ad-card">
                <div className="ad-card-icon">🎓</div>
                <div><h3>Students</h3><p className="ad-card-value">{totalStudents}</p></div>
              </div>
              <div className="ad-card">
                <div className="ad-card-icon">🧑‍🏫</div>
                <div><h3>Instructors</h3><p className="ad-card-value">{totalInstructors}</p></div>
              </div>
              <div className="ad-card">
                <div className="ad-card-icon">📚</div>
                <div><h3>Courses</h3><p className="ad-card-value">{courses.length}</p></div>
              </div>
              <div className="ad-card">
                <div className="ad-card-icon">💰</div>
                <div>
                  <h3>Total Revenue</h3>
                  <p className="ad-card-value" style={{ color: "#f5a623" }}>₹{totalRevenue.toLocaleString()}</p>
                </div>
              </div>
            </div>

            <div className="ad-section">
              <h3 className="ad-section-title">Recent Users</h3>
              <div className="ad-table-wrap">
                <table className="ad-table">
                  <thead>
                    <tr>
                      <th>Name</th><th>Email</th><th>Role</th><th>Status</th><th>Joined</th>
                    </tr>
                  </thead>
                  <tbody>
                    {users.slice(0, 3).map(u => (
                      <tr key={u.id}>
                        <td>{u.name}</td>
                        <td style={{ color: "#6b7599" }}>{u.email}</td>
                        <td>
                          <span className={`ad-badge ${u.role === "instructor" ? "ad-badge-orange" : "ad-badge-blue"}`}>
                            {u.role}
                          </span>
                        </td>
                        <td>
                          <span className={`ad-badge ${u.status === "Active" ? "ad-badge-green" : "ad-badge-gray"}`}>
                            {u.status}
                          </span>
                        </td>
                        <td style={{ color: "#6b7599" }}>{u.joined}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="ad-section">
              <h3 className="ad-section-title">Latest Announcements</h3>
              <div className="ad-course-list">
                {announcements.map(a => (
                  <div key={a.id} className="ad-course-row">
                    <div>
                      <p className="ad-course-name">{a.title}</p>
                      <p className="ad-course-meta">{a.message}</p>
                    </div>
                    <span className="ad-due-date">{a.date}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        );

      // ── MANAGE USERS ──
      case "users":
        return (
          <div>
            <div className="ad-top-row">
              <h3 className="ad-section-title" style={{ margin: 0 }}>All Users ({users.length})</h3>
            </div>
            <div className="ad-table-wrap">
              <table className="ad-table">
                <thead>
                  <tr>
                    <th>Name</th><th>Email</th><th>Role</th><th>Status</th><th>Joined</th><th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {users.map(u => (
                    <tr key={u.id}>
                      <td>
                        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                          <div className="ad-avatar">{u.name[0]}</div>
                          {u.name}
                        </div>
                      </td>
                      <td style={{ color: "#6b7599" }}>{u.email}</td>
                      <td>
                        <select
                          className="ad-role-select"
                          value={u.role}
                          onChange={(e) => handleRoleChange(u.id, e.target.value)}
                        >
                          <option value="student">Student</option>
                          <option value="instructor">Instructor</option>
                          <option value="admin">Admin</option>
                        </select>
                      </td>
                      <td>
                        <span className={`ad-badge ${u.status === "Active" ? "ad-badge-green" : "ad-badge-gray"}`}>
                          {u.status}
                        </span>
                      </td>
                      <td style={{ color: "#6b7599" }}>{u.joined}</td>
                      <td>
                        <div style={{ display: "flex", gap: "6px" }}>
                          <button className="ad-btn-sm" onClick={() => handleStatusToggle(u.id)}>
                            {u.status === "Active" ? "Deactivate" : "Activate"}
                          </button>
                          <button
                            className="ad-btn-sm ad-btn-danger"
                            onClick={() => handleDeleteUser(u.id)}
                          >
                            Remove
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        );

      // ── MANAGE COURSES ──
      case "courses":
        return (
          <div>
            <div className="ad-top-row">
              <h3 className="ad-section-title" style={{ margin: 0 }}>All Courses ({courses.length})</h3>
              <button className="ad-btn-primary">+ Add Course</button>
            </div>
            <div className="ad-course-list">
              {courses.map(c => (
                <div key={c.id} className="ad-course-card">
                  <div className="ad-course-card-top">
                    <div>
                      <p className="ad-course-name">{c.title}</p>
                      <p className="ad-course-meta">Instructor: {c.instructor} · {c.students} students</p>
                      <p className="ad-course-meta" style={{ color: "#f5a623", marginTop: "4px" }}>
                        Revenue: ₹{c.revenue.toLocaleString()}
                      </p>
                    </div>
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: "8px" }}>
                      <span className={`ad-badge ${c.status === "Published" ? "ad-badge-green" : "ad-badge-gray"}`}>
                        {c.status}
                      </span>
                      <div style={{ display: "flex", gap: "6px" }}>
                        <button className="ad-btn-sm" onClick={() => handleToggleCourseStatus(c.id)}>
                          {c.status === "Published" ? "Unpublish" : "Publish"}
                        </button>
                        <button className="ad-btn-sm">Edit</button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        );

      // ── ANNOUNCEMENTS ──
      case "announcements":
        return (
          <div>
            <div className="ad-top-row">
              <h3 className="ad-section-title" style={{ margin: 0 }}>Announcements</h3>
              <button className="ad-btn-primary" onClick={() => setShowAnnouncementForm(!showAnnouncementForm)}>
                {showAnnouncementForm ? "Cancel" : "+ New Announcement"}
              </button>
            </div>

            {showAnnouncementForm && (
              <form className="ad-form" onSubmit={handleAddAnnouncement}>
                <h4>New Announcement</h4>
                <input
                  className="ad-input"
                  placeholder="Title"
                  value={newAnnouncement.title}
                  onChange={(e) => setNewAnnouncement({ ...newAnnouncement, title: e.target.value })}
                  required
                />
                <textarea
                  className="ad-input ad-textarea"
                  placeholder="Message"
                  value={newAnnouncement.message}
                  onChange={(e) => setNewAnnouncement({ ...newAnnouncement, message: e.target.value })}
                  required
                />
                <button type="submit" className="ad-btn-primary" style={{ width: "fit-content" }}>
                  Post Announcement
                </button>
              </form>
            )}

            <div className="ad-course-list">
              {announcements.map(a => (
                <div key={a.id} className="ad-course-row">
                  <div>
                    <p className="ad-course-name">{a.title}</p>
                    <p className="ad-course-meta">{a.message}</p>
                  </div>
                  <div style={{ display: "flex", alignItems: "center", gap: "12px", flexShrink: 0 }}>
                    <span className="ad-due-date">{a.date}</span>
                    <button className="ad-btn-sm ad-btn-danger" onClick={() => handleDeleteAnnouncement(a.id)}>
                      Delete
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        );

      // ── ANALYTICS ──
      case "analytics":
        return (
          <div>
            <h3 className="ad-section-title">Platform Analytics</h3>
            <div className="ad-cards">
              <div className="ad-card">
                <div className="ad-card-icon">📈</div>
                <div><h3>Total Enrollments</h3><p className="ad-card-value">202</p></div>
              </div>
              <div className="ad-card">
                <div className="ad-card-icon">💰</div>
                <div>
                  <h3>Total Revenue</h3>
                  <p className="ad-card-value" style={{ color: "#f5a623" }}>₹{totalRevenue.toLocaleString()}</p>
                </div>
              </div>
              <div className="ad-card">
                <div className="ad-card-icon">⭐</div>
                <div><h3>Avg Rating</h3><p className="ad-card-value">4.7</p></div>
              </div>
              <div className="ad-card">
                <div className="ad-card-icon">✅</div>
                <div><h3>Completion Rate</h3><p className="ad-card-value">68%</p></div>
              </div>
            </div>

            <div className="ad-section">
              <h3 className="ad-section-title">Revenue by Course</h3>
              <div className="ad-course-list">
                {courses.map(c => {
                  const pct = totalRevenue > 0 ? Math.round((c.revenue / totalRevenue) * 100) : 0;
                  return (
                    <div key={c.id} className="ad-course-card">
                      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
                        <p className="ad-course-name">{c.title}</p>
                        <p style={{ color: "#f5a623", fontWeight: "600" }}>₹{c.revenue.toLocaleString()}</p>
                      </div>
                      <div className="ad-progress-bar">
                        <div className="ad-progress-fill" style={{ width: `${pct}%` }} />
                      </div>
                      <p className="ad-course-meta" style={{ marginTop: "6px" }}>{pct}% of total revenue</p>
                    </div>
                  );
                })}
              </div>
            </div>

            <div className="ad-section">
              <h3 className="ad-section-title">Enrollment by Course</h3>
              <div className="ad-course-list">
                {courses.map(c => {
                  const maxStudents = Math.max(...courses.map(x => x.students), 1);
                  const pct = Math.round((c.students / maxStudents) * 100);
                  return (
                    <div key={c.id} className="ad-course-card">
                      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
                        <p className="ad-course-name">{c.title}</p>
                        <p style={{ color: "white", fontWeight: "600" }}>{c.students} students</p>
                      </div>
                      <div className="ad-progress-bar">
                        <div className="ad-progress-fill" style={{ width: `${pct}%` }} />
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        );

      // ── SETTINGS ──
      case "settings":
        return (
          <div>
            <h3 className="ad-section-title">Platform Settings</h3>

            <div className="ad-form">
              <h4>General</h4>
              <div>
                <label style={{ fontSize: "0.8rem", color: "#6b7599", display: "block", marginBottom: "6px" }}>
                  Platform Name
                </label>
                <input className="ad-input" defaultValue="Codeion" />
              </div>
              <div>
                <label style={{ fontSize: "0.8rem", color: "#6b7599", display: "block", marginBottom: "6px" }}>
                  Support Email
                </label>
                <input className="ad-input" defaultValue="support@codeion.in" type="email" />
              </div>
              <div>
                <label style={{ fontSize: "0.8rem", color: "#6b7599", display: "block", marginBottom: "6px" }}>
                  Support Hours
                </label>
                <input className="ad-input" defaultValue="Mon–Sat, 10AM–7PM IST" />
              </div>
              <button className="ad-btn-primary" style={{ width: "fit-content" }}>Save Settings</button>
            </div>

            <div className="ad-form">
              <h4>Enrollment Settings</h4>
              <div>
                <label style={{ fontSize: "0.8rem", color: "#6b7599", display: "block", marginBottom: "6px" }}>
                  Default Enrollment Status
                </label>
                <select className="ad-input" style={{ background: "#0b1020" }}>
                  <option value="pending_payment">Pending Payment</option>
                  <option value="active">Active</option>
                  <option value="on_hold">On Hold</option>
                </select>
              </div>
              <div>
                <label style={{ fontSize: "0.8rem", color: "#6b7599", display: "block", marginBottom: "6px" }}>
                  Refund Window (days)
                </label>
                <input className="ad-input" defaultValue="7" type="number" />
              </div>
              <button className="ad-btn-primary" style={{ width: "fit-content" }}>Save</button>
            </div>

            <div className="ad-form">
              <h4 style={{ color: "#f87171" }}>Danger Zone</h4>
              <p style={{ fontSize: "0.85rem", color: "#6b7599" }}>
                These actions are irreversible. Proceed with caution.
              </p>
              <button className="ad-btn-sm ad-btn-danger" style={{ padding: "10px 18px", fontSize: "0.9rem" }}>
                Clear All Test Enrollments
              </button>
            </div>
          </div>
        );

      // ── PROFILE ──
      case "profile":
        return (
          <div>
            <h3 style={{ marginBottom: "20px", color: "#b7c0e0", fontSize: "1rem", fontWeight: "600" }}>My Profile</h3>
            <div style={{
              background: "#121a32", padding: "24px", borderRadius: "10px",
              display: "flex", alignItems: "center", gap: "20px", marginBottom: "24px"
            }}>
              <div>
                {hasPhoto ? (
                  <img src={profilePhoto} alt="profile" referrerPolicy="no-referrer"
                    style={{ width: "70px", height: "70px", borderRadius: "50%", border: "3px solid #f5a623", objectFit: "cover" }}
                    onError={(e) => { e.target.style.display = "none"; e.target.nextSibling.style.display = "flex"; }}
                  />
                ) : null}
                <div style={{
                  width: "70px", height: "70px", borderRadius: "50%", background: "#f5a623",
                  color: "black", display: hasPhoto ? "none" : "flex", alignItems: "center",
                  justifyContent: "center", fontSize: "1.6rem", fontWeight: "700"
                }}>
                  {getInitials()}
                </div>
              </div>
              <div>
                <h2 style={{ fontSize: "1.2rem", marginBottom: "4px" }}>{displayName}</h2>
                <p style={{ fontSize: "0.85rem", color: "#f5a623", marginBottom: "4px" }}>{userData?.userID || "ADM-XXXXXX"}</p>
                <p style={{ fontSize: "0.85rem", color: "#6b7599", marginBottom: "8px" }}>{user?.email}</p>
                <span className="ad-badge ad-badge-red">Administrator</span>
              </div>
            </div>

            <div className="ad-form">
              <h4>Personal Information</h4>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px" }}>
                <div>
                  <label style={{ fontSize: "0.8rem", color: "#6b7599", display: "block", marginBottom: "6px" }}>Full Name</label>
                  <input className="ad-input" placeholder="Your full name" defaultValue={displayName} />
                </div>
                <div>
                  <label style={{ fontSize: "0.8rem", color: "#6b7599", display: "block", marginBottom: "6px" }}>Phone Number</label>
                  <input className="ad-input" placeholder="+91 XXXXX XXXXX" defaultValue={userData?.phone || ""} type="tel" />
                </div>
              </div>
              <div>
                <label style={{ fontSize: "0.8rem", color: "#6b7599", display: "block", marginBottom: "6px" }}>Email Address</label>
                <input className="ad-input" defaultValue={user?.email || ""} disabled style={{ opacity: 0.6 }} />
              </div>
              <div>
                <label style={{ fontSize: "0.8rem", color: "#6b7599", display: "block", marginBottom: "6px" }}>Role / Designation</label>
                <input className="ad-input" defaultValue="Platform Administrator" />
              </div>
              <div>
                <label style={{ fontSize: "0.8rem", color: "#6b7599", display: "block", marginBottom: "6px" }}>Bio</label>
                <textarea className="ad-input ad-textarea" placeholder="About you..."
                  defaultValue={userData?.bio || ""} style={{ minHeight: "80px" }} />
              </div>
              <button className="ad-btn-primary" style={{ width: "fit-content" }}>Save Profile</button>
            </div>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div className="ad-layout">
      <aside className="ad-sidebar">
        <h2 className="ad-logo">CODE<span>ION</span></h2>
        <p className="ad-role-tag">Admin Portal</p>

        <nav className="ad-nav">
          {menuItems.map((item) => (
            <button
              key={item.key}
              className={`ad-nav-btn ${active === item.key ? "ad-nav-active" : ""}`}
              onClick={() => setActive(item.key)}
            >
              <span>{item.icon}</span>
              <span>{item.label}</span>
            </button>
          ))}
        </nav>

        <div className="ad-sidebar-footer">
          <p>{userData?.userID || user?.email}</p>
          <button className="ad-logout-btn" onClick={logout}>Logout</button>
        </div>
      </aside>

      <main className="ad-main">
        <div className="ad-topbar">
          <h2 className="ad-page-title">
            {menuItems.find((m) => m.key === active)?.icon}{" "}
            {menuItems.find((m) => m.key === active)?.label}
          </h2>

          <div className="ad-user-profile" onClick={() => setOpenDropdown(!openDropdown)}>
            {hasPhoto ? (
              <img
                src={profilePhoto}
                alt="profile"
                className="ad-profile-img-sm"
                referrerPolicy="no-referrer"
                onError={(e) => { e.target.style.display = "none"; e.target.nextSibling.style.display = "flex"; }}
              />
            ) : null}
            <div className="ad-fallback-sm" style={{ display: hasPhoto ? "none" : "flex" }}>
              {getInitials()}
            </div>
            <span>{displayName}</span>
            {openDropdown && (
              <div className="ad-dropdown">
                <button onClick={() => { setActive("profile"); setOpenDropdown(false); }}>Profile</button>
                <button onClick={logout}>Logout</button>
              </div>
            )}
          </div>
        </div>

        {successMsg && <div className="ad-success-msg">{successMsg}</div>}
        <div className="ad-body">{renderContent()}</div>
      </main>
    </div>
  );
}

export default AdminDashboard;
